<template>
  <div v-if="isProject">
    <div>
      <div>
        <div>
          <div class="box-body">
            <!--  -->
            <div class="col-md-12">
              <!-- <div class="panel with-nav-tabs panel-info">
                <div class="panel-heading">
                  <ul class="nav nav-tabs">
                    <li class="active">
                      <a href="#tab1warning" data-toggle="tab">{{
                        $t("customization_table.smtp_title")
                      }}</a>
                    </li>
                  </ul>
                </div> -->
              <!-- <div class="panel-body"> -->
              <div>
                <div class="custom-control custom-radio">
                  <input
                    type="radio"
                    id="customRadio1"
                    name="customRadio"
                    class="custom-control-input"
                    v-model="useSMTPProject"
                    :value="false"
                    @change="onShowConfirm()"
                  />
                  <label class="custom-control-label" for="customRadio1">{{
                    $t("customSMTPConfig.useSystemConfig")
                  }}</label>
                </div>
                <div class="custom-control custom-radio">
                  <input
                    type="radio"
                    id="customRadio2"
                    name="customRadio"
                    class="custom-control-input"
                    v-model="useSMTPProject"
                    :value="true"
                    @change="onShowConfirm()"
                  />
                  <label class="custom-control-label" for="customRadio2">{{
                    $t("customSMTPConfig.useCustomConfig")
                  }}</label>
                </div>
              </div>
              <div v-if="confirmUseSMTPProject" class="row" >
                <div class="col-sm-12 col-md-6" style="display: flex;">
                  <span
                    v-for="(item, index) in tabList"
                    :key="item + index"
                    :class="
                      `${
                        index !== tabList.length - 1
                          ? 'customer-type-class border-right'
                          : 'customer-type-class'
                      }`
                    "
                    @click="onChangeTab(item.value)"
                  >
                    <span
                      :class="
                        item.value === tabSelect ? 'customer-type-select' : ''
                      "
                      style="white-space: nowrap;"
                    >
                      {{ $t(item.text) }}
                      <!-- ({{ item.total }}) -->
                    </span>
                  </span>
                </div>
                <div class="col-sm-12 col-md-6">
                  <button
                    v-if="GET_ACCOUNT_DATA.id === 1"
                    type="button"
                    class="btn btn-labeled btn-primary pull-right"
                    style="margin-right: 5px;"
                    @click="onChangeSMTPProject"
                  >
                    <span class="btn-label">
                      <i class="glyphicon glyphicon-th"></i>
                    </span>
                    {{ $t("customization_table.selectSMTPProject") }}
                  </button>
                </div>
              </div>
              <hr style="margin: 10px 0 15px 0" />
              <div class="tab-content" v-if="confirmUseSMTPProject">
                <div class="tab-pane fade in active" id="tab1warning">
                  <!-- SMTP Project -->
                  <div>
                    <b-card
                      no-body
                      class="mb-1"
                      v-if="show_smtp_project == showServerSetting.ShowInfo"
                    >
                      <b-card-header header-tag="header" class="p-1" role="tab">
                        <b-button block v-b-toggle.accordion-2 variant="info">{{
                          $t("customization_table.smtp_project.title")
                        }}</b-button>
                      </b-card-header>
                      <b-collapse
                        id="accordion-2"
                        visible
                        accordion="my-accordion"
                        role="tabpanel"
                      >
                        <b-card-body>
                          <div class="box-body">
                            <!-- only superadmin -->
                            <div class="col-md-6">
                              <div class="form-group">
                                <label for="title">{{
                                  $t(
                                    "customization_table.smtp_project.project_name"
                                  )
                                }}</label>
                                <input
                                  type="text"
                                  class="form-control"
                                  v-model="smtp_project.project_name"
                                  :placeholder="
                                    $t(
                                      'customization_table.smtp_project.project_name'
                                    )
                                  "
                                />
                              </div>
                            </div>

                            <div class="col-md-6">
                              <div class="form-group">
                                <label for="title">{{
                                  $t("customization_table.smtp_project.alias")
                                }}</label>
                                <input
                                  type="text"
                                  class="form-control"
                                  v-model="smtp_project.alias"
                                  :placeholder="
                                    $t('customization_table.smtp_project.alias')
                                  "
                                />
                              </div>
                            </div>
                            <!-- only superadmin -->
                            <div class="col-md-12">
                              <div class="form-group">
                                <label for="title">{{
                                  $t(
                                    "customization_table.smtp_project.description"
                                  )
                                }}</label>
                                <input
                                  type="text"
                                  class="form-control"
                                  v-model="smtp_project.description"
                                  :placeholder="
                                    $t(
                                      'customization_table.smtp_project.description'
                                    )
                                  "
                                />
                              </div>
                            </div>

                            <div class="col-md-6">
                              <div class="form-group">
                                <label for="title">{{
                                  $t(
                                    "customization_table.smtp_project.page_size"
                                  )
                                }}</label>
                                <input
                                  type="number"
                                  class="form-control"
                                  v-model="smtp_project.page_size"
                                  :placeholder="
                                    $t(
                                      'customization_table.smtp_project.page_size'
                                    )
                                  "
                                />
                              </div>
                            </div>

                            <div class="col-md-12">
                              <div class="form-group">
                                <label for="title">{{
                                  $t(
                                    "customization_table.smtp_project.sub_content"
                                  )
                                }}</label>
                                <textarea
                                  rows="8"
                                  type="text"
                                  class="form-control"
                                  v-model="smtp_project.sub_content"
                                  :placeholder="
                                    $t(
                                      'customization_table.smtp_project.sub_content'
                                    )
                                  "
                                />
                              </div>
                            </div>
                            <div class="box-footer" style="padding-bottom: 0">
                              <button
                                type="button"
                                class="btn btn-labeled btn-success pull-right"
                                style="margin-right: 5px"
                                @click="onSave_SMTP_Project"
                              >
                                <span class="btn-label">
                                  <i class="glyphicon glyphicon-ok"></i>
                                </span>
                                {{ $t("common.save") }}
                              </button>
                            </div>
                          </div>
                        </b-card-body>
                      </b-collapse>
                    </b-card>
                    <div
                      v-else-if="
                        show_smtp_project == showServerSetting.ErrorLogin
                      "
                    >
                      <p
                        v-if="GET_ACCOUNT_DATA.id == 1"
                        style="color: red; text-align: center"
                      >
                        {{
                          $t("customization_table.smtp_server.info_incorrect")
                        }}
                      </p>
                      <p v-else style="color: red; text-align: center">
                        {{
                          $t(
                            "customization_table.smtp_server.info_incorrect_for_user"
                          )
                        }}
                      </p>
                    </div>
                    <div v-else>
                      <p style="color: red; text-align: center">
                        {{ $t("customization_table.error_connect_server") }}
                      </p>
                    </div>
                  </div>
                  <!--  -->
                  <!-- SMTP Email -->
                  <b-card
                    no-body
                    class="mb-1"
                    v-if="show_smtp_project == showServerSetting.ShowInfo"
                  >
                    <b-card-header header-tag="header" class="p-1" role="tab">
                      <b-button block v-b-toggle.accordion-3 variant="info">{{
                        $t("customization_table.smtp_email.title")
                      }}</b-button>
                    </b-card-header>
                    <b-collapse
                      id="accordion-3"
                      accordion="my-accordion"
                      role="tabpanel"
                    >
                      <b-card-body>
                        <div class="box-body">
                          <div class="col-md-6">
                            <div class="form-group">
                              <label for="title">{{
                                $t("customization_table.smtp_email.email_host")
                              }}</label>
                              <input
                                type="text"
                                class="form-control"
                                v-model="smtp_email.email_host"
                                :placeholder="
                                  $t(
                                    'customization_table.smtp_email.email_host'
                                  )
                                "
                              />
                            </div>
                          </div>

                          <div class="col-md-6">
                            <div class="form-group">
                              <label for="title">{{
                                $t("customization_table.smtp_email.port")
                              }}</label>
                              <input
                                type="number"
                                class="form-control"
                                v-model="smtp_email.port"
                                :placeholder="
                                  $t('customization_table.smtp_email.port')
                                "
                              />
                            </div>
                          </div>
                          <div class="col-md-6">
                            <div class="form-group">
                              <label for="title">{{
                                $t(
                                  "customization_table.smtp_email.email_user_host"
                                )
                              }}</label>
                              <input
                                type="text"
                                class="form-control"
                                v-model="smtp_email.email_user_host"
                                :placeholder="
                                  $t(
                                    'customization_table.smtp_email.email_user_host'
                                  )
                                "
                              />
                            </div>
                          </div>
                          <div class="col-md-6">
                            <div class="form-group">
                              <label for="title">{{
                                $t(
                                  "customization_table.smtp_email.password_email"
                                )
                              }}</label>
                              <input
                                class="form-control"
                                v-model="smtp_email.password_email"
                                type="password"
                                id="password_email"
                                :placeholder="
                                  $t(
                                    'customization_table.smtp_email.password_email'
                                  )
                                "
                              />
                            </div>
                          </div>
                          <div class="col-md-6">
                            <div class="form-group">
                              <input
                                type="checkbox"
                                v-model="smtp_email.email_user_tls"
                                :placeholder="
                                  $t(
                                    'customization_table.smtp_project.page_size'
                                  )
                                "
                              />
                              <label for="title">{{
                                $t(
                                  "customization_table.smtp_email.email_user_tls"
                                )
                              }}</label>
                            </div>
                          </div>
                        </div>
                        <div class="box-footer" style="padding-bottom: 0">
                          <button
                            type="button"
                            class="btn btn-labeled btn-warning"
                            style="margin-right: 5px"
                            @click="sendTestEmail"
                          >
                            <span class="btn-label">
                              <i class="glyphicon glyphicon-ok"></i>
                            </span>
                            {{ $t("common.sendTest") }}
                          </button>
                          <button
                            type="button"
                            class="btn btn-labeled btn-success pull-right"
                            style="margin-right: 5px"
                            @click="save_Config_SMTP_Email_Server"
                          >
                            <span class="btn-label">
                              <i class="glyphicon glyphicon-ok"></i>
                            </span>
                            {{ $t("common.save") }}
                          </button>
                        </div>
                      </b-card-body>
                    </b-collapse>
                  </b-card>
                  <!--  -->
                </div>
                <!-- SMTP Project -->
              </div>
              <!-- </div> -->
              <!-- </div> -->
            </div>
            <!--  -->
          </div>
        </div>
      </div>
    </div>
    <lte-core-alert
      v-for="snackbar in GET_SNACK_BAR"
      :key="snackbar.id"
      :item="snackbar"
    ></lte-core-alert>
    <loading :active.sync="is_loading" :can-cancel="false" color="#1E90FF">
    </loading>
    <lte-modal
      v-show="isModalVisible"
      @onConfirm="onChangeUseCustom"
      @close="closeModal"
      v-for="obj in objModal"
      :key="obj.id"
      :item="obj"
    ></lte-modal>
    <!--  -->
    <div class="modal modal-default" id="modal-select-project-smtp">
      <div class="modal-dialog">
        <div class="modal-content" style="top: 100px">
          <div class="modal-header">
            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
            <h4 class="modal-title">{{$t('customization_table.selectSMTPProject')}}</h4>
          </div>
          <div class="modal-body">
            <div class="form-group">
              <label
                for="title"
              >{{$t('customization_table.smtp_server.smtp_project')}}</label>
              <select
                name=""
                id=""
                class="form-control"
                v-model="smtpProjectId"
              >
                <option
                  v-for="(smtpProject, index) in smtpProjectList"
                  :key="smtpProject + index"
                  :value="smtpProject.id"
                  >{{ smtpProject.project_name }}</option
                >
              </select>
            </div>
          </div>
          <div class="modal-footer">
            <button
              type="button"
              class="btn btn-default pull-left"
              data-dismiss="modal"
              >{{$t('confirm_email.btnClose')}}
            </button>
            <button
              type="button"
              class="btn btn-primary pull-right"
              @click="onSaveSMPTProject"
              >{{$t('confirm_email.btnConfirm')}}
            </button>
          </div>
        </div>
      </div>
    </div>
    <sendTestEmailModal ref="sendEmailTesting" />
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import LTECoreAlert from "@/components/LTESnackBar.vue";
import Loading from "vue-loading-overlay";
import Enum from "../../../enum/enum";
import LTEModal from "@/components/LTEModal.vue";
import utils from '@/lib/utils';
import SendTestEmailModal from "./SendTestEmailModal.vue"

export default {
  name: "CustomizationTable_SMTP",
  data() {
    return {
      isProject: null,
      smtpProjectId: null,
      useSMTPProject: false,
      confirmUseSMTPProject: false,
      password_length: 0,
      password_typed: false,
      contain_lowercase: false,
      contain_uppercase: false,
      contain_number: false,
      valid_password_length: false,
      valid_password: false,
      smtp_project: {
        project_name: "",
        alias: "",
        page_size: null,
        sub_content: "",
        description: ""
      },
      is_loading: false,
      show_smtp_project: Enum.showServerSetting.ErrorLogin,
      showServerSetting: Enum.showServerSetting,
      smtp_email: {
        email_host: null,
        email_user_host: null,
        port: null,
        password_email: null,
        email_user_tls: true
      },
      isModalVisible: false,
      objModal: [
        {
          title: "customSMTPConfig.title",
          body: "customSMTPConfig.notificationChangeUseSMTPConfig",
          buttonNo: "customSMTPConfig.cancel",
          buttonYes: "customSMTPConfig.confirm",
          styleType: "default"
        }
      ],
      tabList: [
        {
          value: Enum.ProjectSMTPCustomEnum.MANAGEMENT_SMTP,
          text: "customization_table.customSMTPService.management_SMTP",
          total: 0
        },
        {
          value: Enum.ProjectSMTPCustomEnum.CSKH_SMTP,
          text: "customization_table.customSMTPService.CSKH_SMTP",
          total: 0
        }
      ],
      tabSelect: Enum.ProjectSMTPCustomEnum.MANAGEMENT_SMTP,
      projectSMTPCustomEnum: Enum.ProjectSMTPCustomEnum,
      smtpProjectList: [],
    };
  },
  watch: {
    GET_SMTP_PROJECT_DATA: function() {
      this.smtp_project.project_name = this.GET_SMTP_PROJECT_DATA.project_name;
      this.smtp_project.alias = this.GET_SMTP_PROJECT_DATA.alias;
      this.smtp_project.sub_content = this.GET_SMTP_PROJECT_DATA.tail_content;
      this.smtp_project.page_size = this.GET_SMTP_PROJECT_DATA.pagination;
      this.smtp_project.description = this.GET_SMTP_PROJECT_DATA.description;
    },
    GET_CONFIG_SMTP_EMAIL_SERVER_DATA: function() {
      this.smtp_email.email_host = this.GET_CONFIG_SMTP_EMAIL_SERVER_DATA.email_host;
      this.smtp_email.email_user_host = this.GET_CONFIG_SMTP_EMAIL_SERVER_DATA.email_user_host;
      this.smtp_email.port = this.GET_CONFIG_SMTP_EMAIL_SERVER_DATA.port;
      this.smtp_email.email_user_tls = this.GET_CONFIG_SMTP_EMAIL_SERVER_DATA.email_user_tls;
      this.smtp_email.password_email = null;
    },
    GET_USE_CUSTOM_SMTP_CONFIG_DATA: function() {
      this.smtpProjectId = this.GET_USE_CUSTOM_SMTP_CONFIG_DATA.smtp_project_id;
      this.useSMTPProject = this.GET_USE_CUSTOM_SMTP_CONFIG_DATA.use_smtp_project;
      this.confirmUseSMTPProject = this.useSMTPProject;
      if (this.smtpProjectId != null) {
        this.getSMTPEmailServer();
        this.getSMTPProject();
      }
    },
    GET_SMTP_PROJECT_LIST_DATA: function() {
      this.smtpProjectList = [];
      this.GET_SMTP_PROJECT_LIST_DATA.forEach(data => {
        let item = {
          id: data.id,
          project_name: data.project_name
        };
        this.smtpProjectList.push(item);
      });
    }
  },
  computed: {
    ...mapGetters([
      "GET_SNACK_BAR",
      "GET_CUSTOM_SMTP_CONFIG_PROJECT_DATA",
      "GET_CONFIG_SMTP_EMAIL_SERVER_DATA",
      "GET_ACCOUNT_DATA",
      "GET_USE_CUSTOM_SMTP_CONFIG_DATA",
      "GET_SMTP_PROJECT_DATA",
      "GET_SMTP_PROJECT_LIST_DATA"
    ])
  },
  methods: {
    ...mapActions([
      "SUCCESS_TOAST",
      "ON_SHOW_TOAST",
      "GET_SMTP_PROJECT",
      "PUSH_CUSTOM_SMTP_PROJECT",
      "GET_CONFIG_SMTP_EMAIL_SERVER",
      "PUSH_CONFIG_SMTP_EMAIL_SERVER",
      "GET_USE_CUSTOM_SMTP_CONFIG",
      "UPDATE_USE_CUSTOM_SMTP_CONFIG",
      "GET_SMTP_PROJECT_LIST",
      "POST_SMTP_PROJECT_SERVICE_CONFIG"
    ]),
    get_data_null: function(data) {
      if (data === null || data === "") {
        return null;
      } else return data;
    },
    onSave_SMTP_Project: function() {
      if (this.smtp_project.page_size <= 0) {
        this.ON_SHOW_TOAST({
          message: "Page size not validate",
          styleType: "danger"
        });
      } else if (utils.isNull(this.smtp_project.project_name)) {
        this.ON_SHOW_TOAST({
          message:
            this.$t("common.errorInput") +
            " " +
            this.$t("customization_table.smtp_project.project_name"),
          styleType: "danger"
        });
      } else {
        let data = {
          project_name: utils.getCleanStringValue(this.smtp_project.project_name),
          alias: utils.getCleanStringValue(this.smtp_project.alias),
          page_size: this.smtp_project.page_size,
          sub_content: utils.getCleanStringValue(this.smtp_project.sub_content),
          description: utils.getCleanStringValue(this.smtp_project.description),
          smtp_project: utils.getCleanStringValue(this.smtpProjectId),
          smtpServiceKey: this.tabSelect
        };
        this.PUSH_CUSTOM_SMTP_PROJECT(data)
          .then(
            function(res) {
              this.SUCCESS_TOAST();
            }.bind(this)
          )
          .catch(
            function(error) {
              this.ON_SHOW_TOAST({
                message: error.response.data.message,
                styleType: "danger"
              });
            }.bind(this)
          );
      }
    },
    getSMTPProject: function() {
      this.is_loading = true;
      let filter = {
        params: {
          smtpServiceKey: this.tabSelect
        }
      };
      this.GET_SMTP_PROJECT(filter)
        .then(
          function(res) {
            this.show_smtp_project = this.showServerSetting.ShowInfo;
            this.is_loading = false;
          }.bind(this)
        )
        .catch(
          function(error) {
            let mess = error.response.data.message;
            if (mess == "error_login") {
              this.show_smtp_project = this.showServerSetting.ErrorLogin;
            } else if (mess == "error_connection") {
              this.show_smtp_project = this.showServerSetting.ErrorConnect;
            } else if (mess == "not_found_custom_smtp_config") {
              this.show_smtp_project = this.showServerSetting.ShowInfo;
            }
            this.is_loading = false;
          }.bind(this)
        );
    },
    // SMTP Email Server
    getSMTPEmailServer: function() {
      this.is_loading = true;
      let filter = {
        params: {
          smtpServiceKey: this.tabSelect
        }
      };
      this.GET_CONFIG_SMTP_EMAIL_SERVER(filter)
        .then(
          function(res) {
            this.show_smtp_project = this.showServerSetting.ShowInfo;
            this.is_loading = false;
          }.bind(this)
        )
        .catch(
          function(error) {
            let mess = error.response.data.message;
            if (mess == "error_login") {
              this.show_smtp_project = this.showServerSetting.ErrorLogin;
            } else if (mess == "error_connection") {
              this.show_smtp_project = this.showServerSetting.ErrorConnect;
            } else if (mess == "not_found_custom_smtp_config") {
              this.show_smtp_project = this.showServerSetting.ShowInfo;
            }
            this.is_loading = false;
          }.bind(this)
        );
    },
    validateData_SMTP_Email: function() {
      let validatedResult = "OK";
      for (let key in this.smtp_email) {
        if (this.smtp_email[key] === null || this.smtp_email[key] === "") {
          validatedResult =
            "Vui Lòng Nhập: " +
            this.$t("customization_table.smtp_email." + key);
          break;
        } else {
          //
        }
      }
      return validatedResult;
    },
    save_Config_SMTP_Email_Server: function() {
      let result = this.validateData_SMTP_Email();
      if (result == "OK") {
        this.is_loading = true;
        let data = {
          email_host: utils.getCleanStringValue(this.smtp_email.email_host),
          email_user_host: utils.getCleanStringValue(this.smtp_email.email_user_host),
          password_email: utils.getCleanStringValue(this.smtp_email.password_email),
          email_user_tls: utils.getCleanStringValue(this.smtp_email.email_user_tls),
          port: utils.getCleanStringValue(this.smtp_email.port),
          smtpServiceKey: this.tabSelect
        };
        this.PUSH_CONFIG_SMTP_EMAIL_SERVER(data)
          .then(
            function(res) {
              this.SUCCESS_TOAST();
              this.getSMTPEmailServer();
            }.bind(this)
          )
          .catch(
            function(error) {
              this.ON_SHOW_TOAST({
                message: error.response.data.message,
                styleType: "danger"
              });
            }.bind(this)
          );
      } else {
        this.ON_SHOW_TOAST({
          message: result,
          styleType: "danger"
        });
      }
    },
    sendTestEmail: function () {
      this.$refs.sendEmailTesting.onShowModal(this.tabSelect)
    },
    onShowConfirm: function() {
      this.isModalVisible = true;
    },
    closeModal() {
      this.isModalVisible = false;
      this.useSMTPProject = !this.useSMTPProject;
    },
    onChangeUseCustom: function() {
      this.confirmUseSMTPProject = this.useSMTPProject;
      let data = {
        enableCustomSMTP: this.useSMTPProject
      };
      this.UPDATE_USE_CUSTOM_SMTP_CONFIG(data)
        .then(
          function(res) {
            this.isModalVisible = false;
            this.SUCCESS_TOAST();
            this.getSMTPEmailServer();
          }.bind(this)
        )
        .catch(
          function(error) {
            this.ON_SHOW_TOAST({
              message: error.response.data.message,
              styleType: "danger"
            });
          }.bind(this)
        );
    },
    onGetData: function() {
      this.isProject = utils.getProjectSession();
      if (this.isProject) {
        const payload = {
          params: {
            smtpServiceKey: this.tabSelect
          }
        };
        this.GET_USE_CUSTOM_SMTP_CONFIG(payload);
        this.GET_SMTP_PROJECT_LIST();
        this.setDataDefault()
      }
    },
    getCallbackData: function() {
      this.getSMTPEmailServer();
      this.getSMTPProject();
    },
    setDataDefault: function() {
      // set data null
      this.smtp_project.project_name = null;
      this.smtp_project.alias = null;
      this.smtp_project.sub_content = null;
      this.smtp_project.page_size = null;
      this.smtp_project.description = null;

      this.smtp_email.email_host = null;
      this.smtp_email.email_user_host = null;
      this.smtp_email.port = null;
      this.smtp_email.email_user_tls = null;
      this.smtp_email.password_email = null;
    },
    //
    onChangeTab: function(value) {
      this.tabSelect = value;
      this.onGetData()
    },
    // 
    onShowModalSelectProject: function () {
      $("#modal-select-project-smtp").modal("show");
    },
    onHideModalSelectProject: function () {
      $("#modal-select-project-smtp").modal("hide");
    },
    onChangeSMTPProject: function() {
      this.onShowModalSelectProject()
    },
    onSaveSMPTProject: function() {
      if (utils.isEmptyString(this.smtpProjectId)) {
        this.ON_SHOW_TOAST({
          message: this.$t('customization_table.smtp_server.smtp_project'),
          styleType: "danger"
        });
      } else {
        let data = {
          smtpServiceKey: this.tabSelect,
          smtpProject: this.smtpProjectId
        }
        this.POST_SMTP_PROJECT_SERVICE_CONFIG(data)
        .then(
          function(res) {
            this.SUCCESS_TOAST();
            this.onHideModalSelectProject()
            this.getCallbackData();
          }.bind(this)
        )
        .catch(
          function(error) {
            this.ON_SHOW_TOAST({
              message: error.response.data.message,
              styleType: "danger"
            });
          }.bind(this)
        );
      }
    }
  },
  mounted() {
  },
  components: {
    "lte-core-alert": LTECoreAlert,
    "lte-modal": LTEModal,
    loading: Loading,
    SendTestEmailModal
  }
};
</script>

<style scoped>
.panel.with-nav-tabs .panel-heading {
  padding: 5px 5px 0 5px;
}
.panel.with-nav-tabs .nav-tabs {
  border-bottom: none;
}
.panel.with-nav-tabs .nav-justified {
  margin-bottom: -1px;
}
/********************************************************************/
/*** PANEL WARNING ***/
.with-nav-tabs.panel-warning .nav-tabs > li > a,
.with-nav-tabs.panel-warning .nav-tabs > li > a:hover,
.with-nav-tabs.panel-warning .nav-tabs > li > a:focus {
  color: #8a6d3b;
}
.with-nav-tabs.panel-warning .nav-tabs > .open > a,
.with-nav-tabs.panel-warning .nav-tabs > .open > a:hover,
.with-nav-tabs.panel-warning .nav-tabs > .open > a:focus,
.with-nav-tabs.panel-warning .nav-tabs > li > a:hover,
.with-nav-tabs.panel-warning .nav-tabs > li > a:focus {
  color: #8a6d3b;
  background-color: #faebcc;
  border-color: transparent;
}
.with-nav-tabs.panel-warning .nav-tabs > li.active > a,
.with-nav-tabs.panel-warning .nav-tabs > li.active > a:hover,
.with-nav-tabs.panel-warning .nav-tabs > li.active > a:focus {
  color: #8a6d3b;
  background-color: #fff;
  border-color: #faebcc;
  border-bottom-color: transparent;
}
.with-nav-tabs.panel-warning .nav-tabs > li.dropdown .dropdown-menu {
  background-color: #fcf8e3;
  border-color: #faebcc;
}
.with-nav-tabs.panel-warning .nav-tabs > li.dropdown .dropdown-menu > li > a {
  color: #8a6d3b;
}
.with-nav-tabs.panel-warning
  .nav-tabs
  > li.dropdown
  .dropdown-menu
  > li
  > a:hover,
.with-nav-tabs.panel-warning
  .nav-tabs
  > li.dropdown
  .dropdown-menu
  > li
  > a:focus {
  background-color: #faebcc;
}
.with-nav-tabs.panel-warning
  .nav-tabs
  > li.dropdown
  .dropdown-menu
  > .active
  > a,
.with-nav-tabs.panel-warning
  .nav-tabs
  > li.dropdown
  .dropdown-menu
  > .active
  > a:hover,
.with-nav-tabs.panel-warning
  .nav-tabs
  > li.dropdown
  .dropdown-menu
  > .active
  > a:focus {
  color: #fff;
  background-color: #8a6d3b;
}
/*  */
.lnu_container {
  display: block;
  margin: 10px auto;
  margin-bottom: 0;
  width: 100%;
  height: auto;
  display: flex;
  justify-content: space-between;
}
.lnu_container p {
  width: 30%;
  height: auto;
  font-size: 12px;
  line-height: 1.2;
  text-align: center;
  border-radius: 2px;
  color: rgba(71, 87, 98, 0.8);
  background: linear-gradient(to right, #06a65a 50%, #eee 50%);
  background-size: 200% 100%;
  background-position: right;
  -webkit-transition: background 0.3s;
  transition: background 0.3s;
}
.got_lowercase,
.got_uppercase,
.got_number {
  background-position: left !important;
  color: rgba(255, 255, 255, 0.9) !important;
}
.show_password_length {
  display: block !important;
}
.password_length {
  padding: 2px 8px;
  position: absolute;
  top: 42px;
  right: 21px;
  -webkit-transform: translateY(-50%);
  transform: translateY(-50%);
  background: #dd4b39;
  color: white;
  border-color: #d73925;
  border-radius: 4px;
  font-size: 13px;
  display: none;
  -webkit-transition: all 0.1s;
  transition: all 0.1s;
}
.password_length_modal {
  padding: 2px 8px;
  position: absolute;
  top: 50.3%;
  right: 21px;
  -webkit-transform: translateY(-50%);
  transform: translateY(-50%);
  background: #dd4b39;
  color: white;
  border-color: #d73925;
  border-radius: 4px;
  font-size: 13px;
  display: none;
  -webkit-transition: all 0.1s;
  transition: all 0.1s;
}
.password_length_count {
  background: #06a65a;
  color: rgba(255, 255, 255, 0.9);
}
/*  */
.customer-type-class {
  padding: 5px 15px;
  cursor: pointer;
}
.border-right {
  border-right: 1px solid #000000 !important;
}
.customer-type-select {
  font-weight: bold;
  color: #006ad4;
}
</style>



// WEBPACK FOOTER //
// src/views/Project/CustomizationProject_SMTP.vue